'use strict';

export function extendError(pError, error) {
    if (error && (typeof error === 'object')) {
        ['name', 'errno'].forEach(
            function (property) {
                if (property in error) {
                    this[property] = error[property];
                }
            },
            pError);
    }

    return pError;
}

export function merge(a, b) {
    return { ...a, ...b };
}
